module.exports = __webpack_public_path__ + "static/media/download_googleplay.9f0270e0.png";